import React, { useState } from "react";
import { EditFilled, DeleteFilled, EditOutlined, DeleteOutlined, QuestionCircleOutlined, ImportOutlined } from '@ant-design/icons';
import { Modal, Form, Input, Switch, Row, Col, Button, Select, Divider, Space, Alert, message, Popconfirm, Checkbox, Tooltip } from "antd";

import conditional from "../../utils/conditional";
import { apiCall } from "../../utils/Api";
import { urlValidator } from "../../utils/Utils";
import { EyeIcon, EyeSlashIcon } from "../Icons";
import LinkUI from "../UI/LinkUI";

export default function MenuEdit(props) {

    const [form] = Form.useForm();
    const [copy, setCopy] = useState(false);

    const { toggleHighlight = () => { }, menus = [], page = {}, setMenus = () => { }, setToOpenPage = () => { }, setPage = () => { }, close = () => { }, is_new = false } = props;

    const {
        id = 0,
        name = "",
        type = "",
        path = "",
        parent_id = 0,
        can_delete = true,
        visibility = "test",
        new_tab = false,
        order = 0,
        url = "",
        v1_page_id = 0,
    } = page;


    const has_children = menus.some(item => item.parent_id === id) || false;

    const [warn, setWarn] = useState("");

    const [isLink, setIsLink] = useState((url) ? url : false);

    const saveMenuItem = (_f) => {

     
        // Copy form items
        let obj = { ..._f }

        // Optional
        obj.url = (_f["url"]) ? _f["url"] : url;


        if (can_delete) {
            obj.new_tab = _f.hasOwnProperty("new_tab") ? _f["new_tab"] : false;
        } else {
            obj.new_tab = false;
        }


        // Deselecting synthetic link checkbox clears URL
        if (!isLink) {
            obj.url = "";
        }

        // Delete parent id if falsy
        if (!_f.parent_id) {
            delete obj.parent_id;
        }

        // ensure url is empty string if falsey or string null
        if (!obj.url || obj.url === "null") {
            obj.url = "";
        }

        // Save if exists (pass order and id)
        if (id) {
            obj.order = order;
            obj.menu_id = id;
            apiCall("site_content/updateMenu", obj, (_status, _result) => {
                if (_status) {
                    setMenus(_result);
                    close();
                } else {
                    message.error(_result.error);
                }
            })

        } else {
            // Create if it doesn't exist (set order to 0)

            obj.order = 0;
            apiCall("site_content/createMenu", obj, (_status, _result) => {
                if (_status) {
                    setMenus(_result);
                    if (_f.parent_id) {
                        setPage(_result.filter(item => item.parent_id === _f.parent_id && item.order === 0)[0])
                    } else {
                        setPage(_result.filter(item => item.parent_id === null && item.order === 0)[0]);
                        toggleHighlight();
                    }
                    close();
                } else {
                    message.error(_result.error);
                }
            })

        }

    }


    const deleteMenuItem = (_id) => {

        if (!_id) {
            return;
        }

        apiCall("site_content/trashMenu", { menu_id: _id }, (_status, _result) => {
            if (_status) {
                setMenus(_result);
                setToOpenPage(_result);
                message.success("Menu item deleted successfully")
            } else {
                message.error(_result.error)
            }
        })
    }


    const slugify = (_name) => {
        return _name.toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }


    const selectBefore = () => {

        return (
            <Select style={{ "width": "100px" }} defaultValue="https://" className="select-before">
                <Select.Option value={"https://"}>https://</Select.Option>
                <Select.Option value={"http://"}>&nbsp; http://</Select.Option>
            </Select>
        )
    }


    const changeBuiltInState = (e) => {

        if (!can_delete && e !== "hidden") {
            let _name = name.replace(" (unlisted)", "")
            form.setFieldsValue({ "name": _name });
        }

        if (!can_delete && e === "hidden") {
            let _name = name + " (unlisted)";
            form.setFieldsValue({ "name": _name });
        }

    }


    const removeTrailingSlash = (inputString) => {
        // Use a regular expression to remove a trailing slash if it exists
        return inputString.replace(/\/$/, '');
    }


    const linkOut = () => {

        let site_url = removeTrailingSlash(window.sitesettings.url);

        if (url) {
            if (url.substr(0, 4) === "http") {
                window.open(url, "_blank")
            } else {
                window.open(site_url + url, "_blank")
            }
        } else {
            window.open(site_url + path, "_blank")
        }

    }


    const parseMenus = () => {

        let _menus = menus.filter(item => !item.parent_id);

        _menus = _menus.map(item => {
            return {
                value: item.id,
                label: item.name,
                has_content: item.has_content
            }
        });

        _menus.unshift({
            value: 0,
            label: "Root",
            has_content: false
        })

        return _menus;

    }

    const drawEditForm = () => {

        return (
            <>
                {/* <pre>{JSON.stringify(menus, null, 2)}</pre> */}
                <p><strong>{(id) ? "Edit " : "Create New "}Menu Item</strong></p>
                <Divider style={{ "margin": "15px 0px" }} />

                <conditional.true value={(!can_delete)} >
                    <Alert style={{ "padding": "0px 10px", "paddingBottom": "3px" }} type="warning" description={<small>It is not possible to modify or remove built-in menu items.</small>} />
                    <div className="shim" /><div className="shim" /><div className="shim" />
                </conditional.true>

                <conditional.true value={(can_delete && has_children)} >
                    <Alert style={{ "padding": "0px 10px", "paddingBottom": "3px" }} type="warning" description={<small>Menu items with sub-menus cannot display content or be deleted.</small>} />
                    <div className="shim" /><div className="shim" /><div className="shim" />
                </conditional.true>

                <Form form={form} onFinish={(_f) => saveMenuItem(_f)} layout="vertical">
                    <Row gutter={30}>
                        <Col span={16}>
                            <Form.Item name="name" initialValue={name} rules={[{ required: true, message: "Name required" }]} label="Name">
                                <Input disabled={(!can_delete)} placeholder="Name..." />
                            </Form.Item>

                            {(is_new &&
                                <Form.Item name="parent_id" initialValue={parent_id} label="Parent">
                                    <Select onChange={(e, f) => setWarn((f.has_content) ? f.label : "")} options={parseMenus()} />
                                </Form.Item>
                            )}

                            {(is_new &&
                                <Form.Item label="Copy from existing page?">
                                    <Checkbox onChange={(e) => setCopy(e.target.checked)} checked={copy} />
                                </Form.Item>
                            )}


                            {(is_new && copy &&

                                <Form.Item name="duplicate_page_id" initialValue={menus.find(i => i.type === "home").id} label="Select the page from which to copy:">
                                    <Select showSearch
                                        filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={menus.filter(i => i.type === "home" || i.can_delete).map(item => {
                                            return {
                                                value: item.id,
                                                label: item.name,
                                                has_content: item.has_content
                                            }
                                        })} />
                                </Form.Item>
                            )}

                            {(!is_new &&
                                <Form.Item name="parent_id" hidden initialValue={parent_id} label="Parent">
                                    <Input />
                                </Form.Item>
                            )}

                            {((isLink && can_delete && !has_children) && <>

                                <LinkUI form_item={false} value={(url) ? url : ""} onChange={(e) => {
                                    form.setFieldsValue({ "url": e });
                                }} />
                                <Form.Item hidden rules={[{ pattern: "^(http|\/).*", required: true, message: "Must be a valid URL" }]} initialValue={(url) ? url : ""} name="url" label="URL">
                                    <Input disabled={(!isLink)} placeholder="www.example.com" />
                                </Form.Item>
                            </>)}

                            {((isLink && can_delete && !has_children) && <>
                                <Form.Item name="new_tab" valuePropName="checked" initialValue={new_tab} noStyle >
                                    <Checkbox >Open link in a new tab?</Checkbox>
                                </Form.Item>
                                <div className="shim" /><div className="shim" /><div className="shim" />
                            </>)}

                        </Col>

                        <Col span={8}>
                            <Form.Item name="visibility" initialValue={visibility} label={<Tooltip title={<>
                                {(can_delete && <><nobr><strong>Draft:</strong> -  Inaccessible </nobr><br /></>)}
                                <nobr><strong>Visible:</strong> - Accessed on menu / URL</nobr><br />
                                <nobr><strong>Unlisted:</strong> - Accessed solely via URL</nobr><br />
                            </>}><div style={{ "cursor": "pointer" }}>Visibility? <QuestionCircleOutlined style={{ "color": "#aaa", "fontSize": "11px" }} /></div></Tooltip>}>
                                <Select onChange={(e) => changeBuiltInState(e)} style={{ "width": "100%" }}>
                                    {(can_delete && <Select.Option value="test"><div style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div></Select.Option>)}
                                    <Select.Option value="visible"><div style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div></Select.Option>
                                    <Select.Option value="hidden"><div style={{ "color": "#aa119d", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#aa119d" }} />&nbsp; Unlisted</div></Select.Option>
                                </Select>
                            </Form.Item>
                            {((can_delete && !has_children) && <>
                                <Form.Item label="Link?">
                                    <Checkbox onChange={(e) => setIsLink(e.target.checked)} defaultChecked={isLink} ></Checkbox>
                                </Form.Item>
                            </>)}
                        </Col>
                    </Row>

                    {(warn && <div style={{ "color": "#ff4d4f", "textAlign": "center" }}>
                        Heads up, the menu <strong>{warn}</strong> you are putting this under has content. That content will become inaccessible on the customer site.<div className="shim" /><div className="shim" /><div className="shim" />
                    </div>)}

                    <Divider style={{ "margin": "0px 0px" }} />
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                    <div className="float-flex">
                        <div>
                            <Tooltip title={(visibility === "test") ? <small>Draft pages are not accessible</small> : ""}>
                                <Button disabled={(visibility === "test")} onClick={() => linkOut()} type="primary"><ImportOutlined rotate={90} />View Live Page</Button>
                            </Tooltip>
                        </div>
                        <Space>
                            <Button onClick={() => close()}>Cancel</Button>
                            {((can_delete && !has_children && (id !== 0)) && <Popconfirm onConfirm={() => deleteMenuItem(id)} okText="Delete" okType="danger" title="Are you sure?"><Button danger type="primary" >Delete</Button></Popconfirm>)}
                            <Button htmlType="submit" type="primary">Save</Button>
                        </Space>
                    </div>
                </Form>

                <br clear="all" />
            </>
        )

    }


    return (
        <div style={{ "padding": "20px" }}>
            {drawEditForm()}
            {/* <pre>{JSON.stringify(page, null, 2)}</pre> */}
        </div>
    )
}